module.exports = __webpack_public_path__ + "img/03-4iDAS整合数据分析系统.fb1bd7a1.png";